(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ehlo-compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(e){if(!e.target.matches('[data-compare-pick]'))return;const section=e.target.closest('.ehlo-compare');section.querySelectorAll('[data-compare-col="'+e.target.dataset.comparePick+'"]').forEach(cell=>cell.hidden=!e.target.checked);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ehlo-discovery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-ehlo-scroll]');if(!button)return;const rail=button.closest('.ehlo-module').querySelector('.ehlo-product-rail');if(rail)rail.scrollBy({left:Number(button.dataset.ehloScroll)*rail.clientWidth*.85,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ehlo-premium-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle',function(e){if(!e.target.matches('.ehlo-mega')||!e.target.open)return;document.querySelectorAll('.ehlo-mega[open]').forEach(d=>{if(d!==e.target)d.open=false});},true);document.addEventListener('keydown',function(e){if(e.key==='Escape')document.querySelectorAll('.ehlo-mega[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})});document.addEventListener('click',function(e){if(!e.target.closest('.ehlo-premium-header'))document.querySelectorAll('.ehlo-mega[open]').forEach(d=>d.open=false)});
import('@shopify/events').then(({StandardEvents})=>{document.addEventListener(StandardEvents.cartLinesUpdate,event=>{event.promise?.then(({cart,detail})=>{const count=cart?.totalQuantity??detail?.itemCount;if(count!==undefined)document.querySelectorAll('[data-ehlo-cart-count]').forEach(el=>el.textContent=String(count));}).catch(()=>{});});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
